import { Card } from "primereact/card";
import { useEffect, useRef, useState } from "react"
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import SuccessAndComplitionCharts from "./successAndComplitionCharts";
import GaugeChart from "./gaugeChart";
import PatientChart from "./patientChart";
import { Calendar } from "primereact/calendar";
import BarList from "./barList";
import ExerciceAccordion from "./exerciceAccordion";
import { de } from "date-fns/locale";
import { Tooltip } from "primereact/tooltip";

const PlansCard = ({ t, planList, setPlanList, planTimeLine, setPlanTimeLine, rangeForCompletedPlans, setRangeForCompletedPlans, selectedPatient }: any) => {
    const lang = localStorage.getItem("i18nextLng") === "en" ? "en-US" : "tr-TR";
    const scrollRef = useRef<any>(null);

    const [selectedExercise, setSelectedExercise] = useState<any>()
    const [selectedPlan, setSelectedPlan] = useState<any>()

    const [activeIndex, setActiveIndex] = useState<any>(0);

    const planTimeLineOptions = [t("completed"), t("ongoing"), t("upcoming")]

    const [successAndComplitionData, setSuccessAndComplitionData] = useState<any>();

    const [minSelectableDate, setMinSelectableDate] = useState<any>(null);
    const [maxSelectableDate, setMaxSelectableDate] = useState<any>(null);


    const [patientChartState, setPatientChartState] = useState<any>(1)

    useEffect(() => {
        if (planList && planList.length > 0) {
            const index = planList.findIndex((plan: any) => plan?.planName === selectedPatient.planName);
            if(index !== -1) {
                selectPlan(planList[index], true, index);
                setActiveIndex(index);
            }
            else {
                selectPlan(planList[0], true, 0);
                setActiveIndex(0);
            }
        }
        else {
            setSelectedExercise(null);
        }
    }, [planList]);


    useEffect(() => {
        const el = scrollRef.current;

        if (selectedExercise && el) {
            const totalSuccess = selectedExercise.exerciseTimeLine.reduce((acc: number, exercise: any) => acc + (exercise.successPercentage || 0), 0);
            const nonZeroSuccessCount = selectedExercise.exerciseTimeLine.reduce(
                (count: number, exercise: any) => count + ((exercise.successPercentage || 0) > 0 ? 1 : 0),
                0
            );
            const totalCompletion = selectedExercise.exerciseTimeLine.reduce((acc: number, exercise: any) => acc + (exercise.completionPercentage || 0), 0);

            setSuccessAndComplitionData({
                successData: nonZeroSuccessCount > 0 ? Math.round(totalSuccess / nonZeroSuccessCount) : 0,
                complitionData: Math.round(totalCompletion / selectedExercise.exerciseTimeLine.length)
            });

            el.scrollLeft = el.scrollWidth;

            let isDown = false;
            let startX: number;
            let scrollLeft: number;

            const handleMouseDown = (e: MouseEvent) => {
                isDown = true;
                el.classList.add("dragging");
                startX = e.pageX - el.offsetLeft;
                scrollLeft = el.scrollLeft;
            };

            const handleMouseMove = (e: MouseEvent) => {
                if (!isDown) return;
                e.preventDefault();
                const x = e.pageX - el.offsetLeft;
                const walk = x - startX;
                el.scrollLeft = scrollLeft - walk;
            };

            const handleMouseUp = () => {
                isDown = false;
                el.classList.remove("dragging");
            };

            el.addEventListener("mousedown", handleMouseDown);
            el.addEventListener("mousemove", handleMouseMove);
            el.addEventListener("mouseup", handleMouseUp);
            el.addEventListener("mouseleave", handleMouseUp);

            return () => {
                el.removeEventListener("mousedown", handleMouseDown);
                el.removeEventListener("mousemove", handleMouseMove);
                el.removeEventListener("mouseup", handleMouseUp);
                el.removeEventListener("mouseleave", handleMouseUp);
            };
        }
    }, [selectedExercise]);


    const prepareCustomSelectedExerciseList = (plan: any) => {
        const timelineMap: Record<string, { totalCompletion: number, totalSuccess: number, count: number, nonZeroSuccessCount: number }> = {};

        plan.exerciseList.forEach((exercise: any) => {
            exercise.exerciseTimeLine.forEach((item: any) => {
                const date = item.dateWillBeDone;
                if (!timelineMap[date]) {
                    timelineMap[date] = {
                        totalCompletion: item.completionPercentage,
                        totalSuccess: item.successPercentage,
                        count: 1,
                        nonZeroSuccessCount: item.successPercentage > 0 ? 1 : 0
                    };
                } else {
                    timelineMap[date].totalCompletion += item.completionPercentage;
                    timelineMap[date].totalSuccess += item.successPercentage;
                    timelineMap[date].count += 1;
                    if (item.successPercentage > 0) {
                        timelineMap[date].nonZeroSuccessCount += 1;
                    }
                }
            });
        });

        const mergedTimeline = Object.entries(timelineMap).map(([date, stats]) => ({
            exerciseTimeLineDate: null,
            dateWillBeDone: date,
            completionPercentage: stats.totalCompletion / stats.count,
            successPercentage: stats.nonZeroSuccessCount > 0 ? (stats.totalSuccess / stats.nonZeroSuccessCount) : 0
        }));

        const mergedExercise = {
            exerciseId: plan.exerciseList[0]?.exerciseId,
            exerciseName: plan.exerciseList[0]?.exerciseName,
            exerciseImg: plan.exerciseList[0]?.exerciseImg,
            nameKey: plan.exerciseList[0]?.nameKey,
            exerciseTimeLine: mergedTimeline
        };

        setSelectedExercise(mergedExercise);
    };

    const selectPlan = (plan: any, checked: any, index: any) => {
        if (checked) {
            setSelectedPlan(plan);
            setActiveIndex(index)
            prepareCustomSelectedExerciseList(plan);
        } else {
            setSelectedPlan(null);
            setSelectedExercise(planList[index].exerciseList[0]);
        }
    }

    const onSelectedPlanExerciseClick = () => {
        setSelectedPlan(null)
    };

    const handleRangeChange = (e: any) => {
        const [start, end]: [Date | null, Date | null] = e.value || [];

        if (start && !end) {
            const min = new Date(start);
            min.setDate(min.getDate() - 90);

            const max = new Date(start);
            max.setDate(max.getDate() + 90);

            const today = new Date();
            today.setHours(0, 0, 0, 0);

            setMinSelectableDate(min);
            setMaxSelectableDate(max > today ? today : max);

            setRangeForCompletedPlans([start, null]);
        } else {
            setRangeForCompletedPlans([start, end]);
            if (!start || !end) {
                setMinSelectableDate(null);
                setMaxSelectableDate(new Date());
                setRangeForCompletedPlans(null);
                setPlanList([])
            }
        }
    };

    return (
        <>
            <div className="flex align-items-center justify-content-between gap-4">
                <div className="flex align-items-center justify-content-start gap-4">
                    <Dropdown
                        style={{
                            height: '3rem',
                            width: '12rem',
                            borderRadius: "15px",
                            background: "rgba(245, 245, 245, 1)"
                        }}
                        value={planTimeLine}
                        options={planTimeLineOptions}
                        onChange={e => setPlanTimeLine(e.target.value)} />
                    {planTimeLine === t("completed") &&
                        <Calendar
                            style={{
                                height: '3rem',
                                minWidth: '15rem',
                                borderRadius: '15px',
                                background: 'rgba(245, 245, 245, 1)'
                            }}
                            value={rangeForCompletedPlans}
                            onChange={handleRangeChange}
                            selectionMode="range"
                            locale={lang === "en-US" ? "en" : "tr"}
                            hideOnRangeSelection
                            maxDate={maxSelectableDate || new Date()}
                            minDate={minSelectableDate}
                        />
                    }
                </div>

                {selectedExercise &&
                    <div className="flex flex-wrap  align-items-center gap-2">
                        <Button
                            text
                            onClick={() => setPatientChartState(1)}
                            style={{

                                backgroundColor: "rgba(245, 245, 245)",
                                color: patientChartState === 1 ? "#2D3967" : "#9EA4B9",
                                height: "3rem",
                                borderRadius: '15px',
                            }} >
                            <span className="flex justify-content-center align-items-center gap-2 font-bold" style={{ width: "100%" }}>
                                {t("barChart")}
                            </span>
                        </Button>
                        <Button
                            text
                            onClick={() => setPatientChartState(0)}
                            style={{
                                backgroundColor: "rgba(245, 245, 245)",
                                color: patientChartState === 0 ? "#2D3967" : "#9EA4B9",
                                height: "3rem",
                                borderRadius: '15px',
                            }} >
                            <span className="flex justify-content-center align-items-center gap-2 font-bold" style={{ width: "100%" }}>
                                {t("lineChart")}
                            </span>
                        </Button>
                    </div>}
            </div>


            <div className="flex gap-4 planAndProgress" style={{ height: "60vh" }}>
                {!selectedExercise && <div className="flex flex-column gap-2 flex-grow-1 align-items-center justify-content-center">
                    <>
                        <img src="/noPlansImage.png" style={{ width: "25rem", objectFit: "cover" }} />
                        <p className="font-bold text-lg m-0" style={{ color: "#2D3967" }}>{t('noPlans')}</p>
                        <p className="text-sm m-0" style={{ color: "#727A99" }}>{t('shouldAddPlans')}</p>
                    </>
                </div>
                }

                {selectedExercise &&
                    <div className="overflow-auto flex-shrink-0 w-3">
                        <div className="flex flex-column gap-2">
                            <ExerciceAccordion
                                activeIndex={activeIndex}
                                setActiveIndex={setActiveIndex}
                                selectedExercise={selectedExercise}
                                setSelectedExercise={setSelectedExercise}
                                planList={planList}
                                setPlanList={setPlanList}
                                selectedPlan={selectedPlan}
                                selectPlan={selectPlan}
                                onSelectedPlanExerciseClick={onSelectedPlanExerciseClick}
                                planTimeLine={planTimeLine}
                                lang={lang}
                                t={t}

                            />
                        </div>
                    </div>}

                {selectedExercise && <div className="flex flex-column gap-4 flex-shrink-0">
                    <Card className="p-3" style={{ borderRadius: "15px", position: "relative", height: "100%" }} >
                        <div className="flex gap-2 align-items-center">
                            <p className='m-0 font-bold text-lg success-info-icon' style={{ color: "#2D3967", cursor: "default" }}>{t("success")}</p>
                            <Tooltip target=".success-info-icon">
                                <div>
                                    {t("successTooltip")}
                                </div>
                            </Tooltip>
                        </div>
                        <div className="flex  justify-content-center align-items-center h-full">
                            <GaugeChart value={successAndComplitionData?.successData} />
                        </div>

                    </Card>
                    <Card className="p-3" style={{ borderRadius: "15px", position: "relative", height: "100%" }} >
                        <p className='m-0 font-bold text-lg' style={{ color: "#2D3967" }}>{t("complition")}</p>
                        <div className="flex justify-content-center align-items-center h-full">
                            <SuccessAndComplitionCharts value={successAndComplitionData?.complitionData} t={t} mode={"complition"} />
                        </div>
                    </Card>
                </div>
                }

                {selectedExercise && <div className="flex-grow-1" style={{ minWidth: 0 }}>
                    <Card className="p-3 w-full h-full" style={{ borderRadius: "15px" }}>
                        <div className="flex justify-content-between align-items-center" style={{
                            position: 'sticky',
                            left: 0,
                            top: 'auto',
                            color: "#2D3967",
                        }}>
                            <p
                                className="m-0 font-bold text-lg">
                                {t("patientChart")}
                            </p>

                            {patientChartState === 1 && <div className="flex flex-wrap justify-content-end align-items-center gap-4">

                                <div className="flex gap-2 align-items-center">
                                    <div style={{
                                        width: "1rem",
                                        height: "1.5rem",
                                        backgroundRepeat: "no-repeat",
                                        background: "#E0E3EE url('/barLine.png')",
                                        position: "relative",
                                        borderRadius: "35px",
                                        overflow: "hidden",
                                    }}>
                                        <div
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                background: "linear-gradient(to bottom, rgba(35, 207, 149, 0.7), rgba(3, 158, 107, 0.7))",
                                                position: "absolute",
                                                bottom: 0,
                                                borderRadius: "35px 35px 0 0",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "start",
                                                overflow: "hidden"
                                            }}
                                        >
                                        </div>
                                    </div>
                                    <p className="m-0 text" style={{ color: "#2D3967" }}>{t("success")}</p>
                                </div>

                                <div className="flex gap-2 align-items-center">
                                    <div style={{ height: "1px",width:"2rem", border: "1px solid #2D3967" }}></div>
                                    <p className="m-0 text" style={{ color: "#2D3967" }}>{t("completion")}</p>
                                </div>
                            </div>}
                        </div>

                        <div ref={scrollRef} style={{ overflowX: 'auto', width: '100%', height: '100%' }}>
                            {patientChartState === 0 && <PatientChart data={selectedExercise?.exerciseTimeLine} t={t} lang={lang} />}
                            {patientChartState === 1 && <BarList lang={lang} selectedExercise={selectedExercise} />}
                        </div>
                    </Card>

                </div>}
            </div>
        </>

    )
}

export default PlansCard